<template>
  <div class="acr-main">
    <!-- 表格 -->
    <el-table :data="showTableData" max-height="705px" border style="width: 100%">
      <el-table-column prop="name" label="课程名" width="250" fixed>
        <template slot-scope="scope">
          <p class="acr-table-p" v-on:click="openClass(scope.row.id)">{{ scope.row.name }}</p>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="ID" width="330"></el-table-column>
      <el-table-column prop="chapterName" label="归属章节" width="150"></el-table-column>
      <el-table-column prop="classificationName" label="归属分类" width="150"></el-table-column>
      <el-table-column prop="lvlName" label="归属难度" width="150"></el-table-column>
      <el-table-column prop="authorName" label="作者" width="150"></el-table-column>
      <el-table-column prop="viewTimes" label="浏览量" width="100"></el-table-column>
      <el-table-column prop="collectionTimes" label="收藏次数" width="100"></el-table-column>
      <el-table-column prop="trackTime" label="最后修改日期" min-width="200"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openEditCurriculumList(scope.row.id)">编辑</el-button>
          <el-button type="text" size="small" @click="deleteClass(scope.row.id,scope.row.name)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <el-pagination class="acr-pagination" @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   background layout="prev, pager, next" :page-size="9" :pager-count="5"
                   :total="curriculumClassTableData.length">
    </el-pagination>
    <!-- 编辑文章浮窗 -->
    <EditCurriculumClassDialog ref="EditCurriculumClassDialog"></EditCurriculumClassDialog>
  </div>
</template>

<script>

import EditCurriculumClassDialog from "@/views/control/components/curriculum/CurriculumClass/EditCurriculumClassDialog";
import AxiosBase from "@/components/axiosBase";

export default {
  name: "CurriculumClassTable",
  components: {
    EditCurriculumClassDialog
  },
  props: {
    curriculumClassTableData: Array
  },
  data() {
    return {
      showTableData: []
    }
  },
  beforeMount() {
    this.processTableData();
  },
  watch: {
    activationTableData: function () {
      this.processTableData();
    }
  },
  methods: {
    processTableData() {
      if (this.curriculumClassTableData.length > 9) {
        this.showTableData = this.curriculumClassTableData.slice(0, 9)
      } else {
        this.showTableData = this.curriculumClassTableData
      }
    },
    openEditCurriculumList(classId) {
      this.$refs.EditCurriculumClassDialog.bufferId = classId;
      this.$refs.EditCurriculumClassDialog.enterEditClass();
      this.$refs.EditCurriculumClassDialog.dialogFormVisible = true;
    },
    deleteClass(classId, className) {
      this.$prompt('请输入[' + className + ']确认删除文章', '此操作将永久删除该文章', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValidator: function (value) {
          if (value === className) {
            return true;
          } else {
            return "文章名错误,请确认需要删除的文章";
          }
        }
      }).then(() => {
        AxiosBase.axiosDelete("/curriculum-ad/del-curriculum-class", {
          params: {
            id: classId
          }
        }).then(response => {
          if (response !== 0) {
            this.$parent.getClassData();
            this.$message({
              type: 'success',
              message: '删除[' + className + ']成功!'
            });
          }
        })
      })
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      if (val === 1) {
        this.showTableData = this.curriculumClassTableData.slice(0, 9)
      } else {
        this.showTableData = this.curriculumClassTableData.slice((val - 1) * 9, (((val - 1) * 9) + 9))
      }
    },
    openClass(id) {
      window.open(this.$router.resolve("/article/" + id).href)
    }
  }
}
</script>

<style scoped>

.acr-table-p {
  cursor: pointer;
}

</style>